<!-- ============================================================================= -->
<!-- BEATRIZ-ARANGO Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

console.log("consola imprimiendo");

document.addEventListener("DOMContentLoaded", function() {
    const links = document.querySelectorAll("#shopify-section-template--23375731720467__collage_customize_zJBh7g .container_apolo a");

    if (links.length > 0) {  // Verifica si existen elementos
        links.forEach(link => {
            link.setAttribute("target", "_blank");
        });
    }
});


  // Modificar el texto del primer elemento '.collection-filters__item .sidebarBlock .sidebarBlock-headingWrapper .facets__text'
  var elementoDisponibilidad = document.querySelector('.collection-filters__item .sidebarBlock:nth-child(1) .sidebarBlock-headingWrapper .facets__text');
  if (elementoDisponibilidad) {
    elementoDisponibilidad.textContent = "DISPONIBILIDAD";
  };

  // Modificar el texto del segundo elemento '.collection-filters__item .sidebarBlock .sidebarBlock-headingWrapper .facets__text'
  var elementoPrecio = document.querySelector('.collection-filters__item .sidebarBlock:nth-child(2) .sidebarBlock-headingWrapper .facets__text');
  if (elementoPrecio) {
    elementoPrecio.textContent = "PRECIO";
  };


document.addEventListener("DOMContentLoaded", function() {
    // Crear la etiqueta <a>
    const link = document.createElement("a");
    link.href = "https://wa.me/573113413597";   // Enlace a WhatsApp con el número especificado
    link.target = "_blank";                     // Abrir en una nueva pestaña
    link.id = "icono-wp";                       // Asignar el id "icono-wp"

    // Crear la etiqueta <img>
    const image = document.createElement("img");
    image.src = "https://cdn.shopify.com/s/files/1/0896/1399/2211/files/icon-final-w.png?v=1730925102";
    image.alt = "Contactar por WhatsApp";       // Texto alternativo para accesibilidad

    // Insertar la imagen dentro del enlace
    link.appendChild(image);

    // Insertar el enlace en el DOM, aquí lo agregamos al final del <body>
    document.body.appendChild(link);
});
